import { Components } from "@mui/material";
import { grey, warning } from "theme/palette";

const MuiButton: Components["MuiButton"] = {
  styleOverrides: {
    root: {
      "&.MuiButton-textDefault": {
        color: grey[400],
        "&:hover": {
          color: grey[900],
        },
        "&.Mui-disabled": {
          color: grey[100],
        },
      },
      "&.MuiButton-containedDefault": {
        backgroundColor: grey[400],
        color: "#fff",
        "&:hover": {
          backgroundColor: grey[900],
        },
        "&.Mui-disabled": {
          backgroundColor: grey[100],
        },
      },
      "&.MuiButton-outlinedDefault": {
        borderColor: grey[400],
        "&.Mui-disabled": {
          borderColor: grey[100],
        },
        "&:hover": {
          borderColor: grey[900],
          backgroundColor: grey[900],
          color: "#fff",
        },
      },
      "&.MuiButton-textWarning": {
        color: grey[400],
        "&:hover": {
          color: warning.dark,
          backgroundColor: warning.light,
        },
      },
      "&.MuiButton-containedWarning": {
        color: "#fff",
        backgroundColor: grey[400],
        "&:hover": {
          color: warning.dark,
          backgroundColor: warning.light,
        },
      },
    },
    sizeLarge: {
      height: "56px",
    },
    sizeMedium: {
      height: "40px",
    },
    contained: {
      boxShadow: "0px 8px 50px rgba(22, 32, 38, 0.1)",
    },
  },
};

export default MuiButton;
